import { JsonObject, JsonProperty } from 'json2typescript'
import Model from './Model'

@JsonObject('StaticFile')
export default class StaticFile extends Model {
  @JsonProperty('name', String)
  name: string

  constructor(
    id = 0,
    name = '',
  ) {
    super(id)
    this.name = name
  }
}
